import { useState, useEffect } from "react";
import Modal from "../../../layouts/Modal/Modal";
import Axios from "middleware/axiosInstance";
import ButtonComponent from "../../../components/Form/ButtonComponent";
import Loading from "../../../layouts/Loading/Loading";
import InputComponent from "../../../components/Form/InputComponent";
import TextAreaComponent from "../../../components/Form/TextAreaComponent";
import SelectComponent from "../../../components/Form/SelectComponent";
const CreateWarehouse = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [allWareHouse, setAllWareHouse] = useState(null);
  const [newWareHouse, setNewWareHouse] = useState({});
  const [editeWareHouse, setEditeWareHouse] = useState({});

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setNewWareHouse({ ...newWareHouse, [name]: value });
  };

  const changeEditeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditeWareHouse({ ...editeWareHouse, [name]: value });
  };

  const CreateWarehouseHandler = () => {
    Axios.post("/anbar", newWareHouse)
      .then((res) => {
        console.log(res);
        getAllWareHouse();
        setShowAddModal(false);
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const editeWarehouseHandler = () => {
    Axios.put(`/anbar/${selectedItem.id}`, editeWareHouse)
      .then((res) => {
        console.log(res);
        setShowEditModal(false);
      })
      .catch((res) => {
        console.log(res);
      })
      .finally(() => {
        getAllWareHouse();
        setEditeWareHouse(null);
        setSelectedItem(null);
      });
  };

  const getAllWareHouse = () => {
    Axios.get("/anbar")
      .then((res) => {
        setAllWareHouse(res.data);
      })
      .catch(() => {
        setAllWareHouse(false);
        alert("لیست انبارها دریافت نشد");
        console.log("err");
      });
  };

  const deleteWarehouseHandler = () => {
    Axios.delete(`/anbar/${selectedItem.id}`, newWareHouse)
      .then((res) => {
        console.log(res);
        getAllWareHouse();
        setShowAddModal(false);
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const deleteItemHandler = () => {
    if (window.confirm(`آیا انبار "${selectedItem.name}" حذف گردد؟ \n\n هشدار: \n تمام کالاهای مربوط به این انبار نیز حذف می گردد!\n و اسناد شامل این کالاها نیز حذف می گردند!`)) {
      deleteWarehouseHandler();
    }
  };

  useEffect(() => {
    getAllWareHouse();
  }, []);

  const handleSelectRow = (item) => {
    setSelectedItem(item);
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        {showAddModal && (
          <Modal>
            <div className="p-4">
              <InputComponent
                inputName="name"
                inputId="name"
                lableValue="نام:"
                onChange={(e) => handleInputChange(e)}
                inputPlaceholder="انبار مرکزی"
              />
              <SelectComponent
                lableValue="نوع انبار:"
                selectName="type"
                selectId="type"
                options={[
                  {
                    name: "عادی",
                    value: "1",
                  },
                  {
                    name: "فروشگاهی",
                    value: "2",
                  },
                ]}
                onChange={(e) => handleInputChange(e)}
              />
              <TextAreaComponent
                // textareaDefaultValue="dasda"
                lableValue="توضیحات"
                textareaName="description"
                textareaId="description"
                onChange={(e) => handleInputChange(e)}
              />
              <div className="d-flex flex-row justify-content-evenly">
                <ButtonComponent
                  onClick={() => CreateWarehouseHandler()}
                  value="ثبت"
                />
                <ButtonComponent
                  onClick={() => setShowAddModal(false)}
                  value="لغو"
                />
              </div>
            </div>
          </Modal>
        )}
        {showEditModal && (
          <Modal>
            <InputComponent
              inputName="name"
              inputId="name"
              lableValue="نام:"
              onChange={(e) => changeEditeHandler(e)}
              defaultValue={selectedItem.name}
            />
            <SelectComponent
              lableValue="نوع انبار:"
              selectName="type"
              selectId="type"
              options={[
                {
                  name: "عادی",
                  value: "adi",
                },
                {
                  name: "فروشگاهی",
                  value: "froshgahi",
                },
              ]}
              defaultOptionSelected={selectedItem.type}
              onChange={(e) => changeEditeHandler(e)}
            />
            <TextAreaComponent
              lableValue="توضیحات"
              textareaName="description"
              textareaId="description"
              onChange={(e) => changeEditeHandler(e)}
              textareaDefaultValue={selectedItem.description}
            />
            <div className="d-flex flex-row">
              <ButtonComponent
                onClick={() => editeWarehouseHandler()}
                value="ثبت"
              />
              <ButtonComponent
                onClick={() => setShowEditModal(false)}
                value="لغو"
              />
            </div>
          </Modal>
        )}

        <h5 className="title-session">تعریف انبار</h5>

        <div className="d-flex flex-row ">
          <button
            className="bi-custom-button"
            onClick={() => setShowAddModal(true)}
          >
            اضافه کردن
          </button>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? setShowEditModal(true)
                : alert("جهت ویرایش  یک آیتم را انتخاب فرمایید!")
            }
          >
            ویرایش
          </button>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? deleteItemHandler()
                : alert("جهت حذف یک آیتم را انتخاب فرمایید!")
            }
          >
            حذف
          </button>
        </div>
        {allWareHouse ? (
          allWareHouse.length > 0 ? (
            <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
              <thead>
                <tr>
                  <th>آیدی</th>
                  <th>نام</th>
                  <th>نوع</th>
                  <th>توضیحات</th>
                </tr>
              </thead>
              <tbody>
                {allWareHouse.map((wareHouse) => {
                  return (
                    <tr
                      id={wareHouse.id}
                      onClick={() => handleSelectRow(wareHouse)}
                      className={
                        selectedItem
                          ? wareHouse.id === selectedItem.id
                            ? "item-slected"
                            : null
                          : null
                      }
                    >
                      <td>{wareHouse.id}</td>

                      <td>{wareHouse.name}</td>

                      <td>
                        {wareHouse.type === "adi"
                          ? "عادی"
                          : wareHouse.type === "froshgahi"
                          ? "فروشگاهی"
                          : "نامشخص"}
                      </td>

                      <td>{wareHouse.description}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <h1>انباری تعریف نشده</h1>
          )
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default CreateWarehouse;
